import { motion } from 'framer-motion';
import { Layers } from 'lucide-react';
import { AnimatedSection, AnimatedItem, AnimatedCard, staggerContainer } from '@/components/animations';

const steps = [
  {
    num: 1,
    title: 'Criar conta gratuita',
    desc: 'Garantir rigor e histórico.',
  },
  {
    num: 2,
    title: 'Analisar o caso com apoio técnico ElevAdvisor',
    desc: 'Avaliação independente baseada na EN 81.',
  },
  {
    num: 3,
    title: 'Decidir com apoio contínuo (opcional)',
    desc: 'Evolua quando precisar de continuidade.',
  },
];

export function HowItWorksSection() {
  return (
    <section className="py-20 md:py-28 border-t border-border">
      <div className="container">
        <AnimatedSection className="max-w-4xl mx-auto" stagger>
          <AnimatedItem className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent/50 text-foreground text-sm font-medium mb-6">
              <Layers className="w-4 h-4" />
              Como Funciona
            </div>
            <h2 className="text-3xl md:text-4xl font-bold">
              Processo em 3 passos
            </h2>
          </AnimatedItem>

          <motion.div
            className="grid md:grid-cols-3 gap-6"
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '-50px' }}
          >
            {steps.map((step) => (
              <AnimatedCard
                key={step.num}
                className="flex gap-4 p-6 rounded-xl bg-card border border-border"
              >
                <motion.div
                  className="w-10 h-10 rounded-full bg-primary flex items-center justify-center shrink-0"
                  whileHover={{ scale: 1.1 }}
                >
                  <span className="text-primary-foreground font-bold">
                    {step.num}
                  </span>
                </motion.div>
                <div>
                  <h3 className="font-semibold text-foreground mb-1">
                    {step.title}
                  </h3>
                  <p className="text-sm text-muted-foreground">{step.desc}</p>
                </div>
              </AnimatedCard>
            ))}
          </motion.div>
        </AnimatedSection>
      </div>
    </section>
  );
}
